import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE } from "../utils/siteData";

export default function SEO({ title, description, keywords, path = "" }) {
  const fullTitle = title ? `${title} | ${SITE.name}` : SITE.name;
  const url = `${SITE.domain}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
    </Helmet>
  );
}
